import {
  resolveBlockSurfaceForLayout,
  resolveBlockSurfaceHasBackgroundImage,
} from "../domain/block-surface";
import { selectDocument } from "../domain/selectors";
import { useEditorStore } from "../domain/redux/hooks";

export function useEmailBuilderBlockContrastAgainst(
  rowId?: string,
  columnId?: string,
): string | undefined {
  const document = useEditorStore(selectDocument);
  if (!rowId || !columnId) {
    return undefined;
  }
  if (resolveBlockSurfaceHasBackgroundImage(document, rowId, columnId)) {
    return undefined;
  }
  return resolveBlockSurfaceForLayout(document, rowId, columnId);
}
